import type { ErrorComponentProps } from '@tanstack/react-router';
import { GlobalError } from '@/common/components/error/GlobalError';

export const RouteErrorComponent = ({ error }: ErrorComponentProps) => {
  return <GlobalError error={error} />;
};
